// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
import { Auth } from 'app/scripts/db/auth';
import { MemberBoardProfileView } from 'app/scripts/views/member/MemberBoardProfileView';
import Dialog from 'app/scripts/views/lib/dialog';
import { Controller } from 'app/scripts/controller';
import { PopOver } from 'app/scripts/views/lib/pop-over';
import { MemberOnBoardView } from 'app/scripts/views/member-menu-profile/MemberOnBoardView';
import DragSort from 'app/scripts/views/lib/drag-sort';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { BoardHeaderAllMembersView } from 'app/scripts/views/board/BoardHeaderAllMembersView';
import { maybeDisplayMemberLimitsError } from 'app/scripts/views/board-menu/MemberLimitsError';
import { BoardMemberAddMultipleView } from 'app/scripts/views/board-menu/BoardMemberAddMultipleView';
import { featureFlagClient } from '@trello/feature-flag-client';
import {
  LazyBoardInviteModal,
  dialogProps,
} from 'app/src/components/BoardInviteModal';

const MAX_FACEPILE_SIZE = 5;

export const onMemberAdd = function () {
  return this.renderBoardHeaderFacepileDebounced();
};

export const renderBoardHeaderFacepile = function () {
  const $target = this.$('.js-fill-facepile');
  let visibleMembers = this.model.orderedVisibleMembers();
  const numMembers = visibleMembers.length;
  visibleMembers = visibleMembers.slice(0, MAX_FACEPILE_SIZE);
  const overflowMemberCount = numMembers - MAX_FACEPILE_SIZE;

  if (overflowMemberCount > 0) {
    this.$('.js-fill-board-member-count').text(`+${overflowMemberCount}`);
  } else {
    this.$('.js-fill-board-member-count').text('');
  }

  let z = visibleMembers.length;
  const subviews = visibleMembers.map((member) =>
    this.subview(MemberOnBoardView, member, { board: this.model, zIndex: z-- }),
  );

  if ($target.length > 0) {
    this.ensureSubviews(subviews, $target);
  }

  this.defer(() => {
    // Disallow adding members to cards from facepile when board is in template mode
    if (!this.model.isTemplate()) {
      DragSort.refreshDraggableBoardMembers();
    }

    return this.renderPopovers();
  });

  return this;
};

export const openAllMembers = function (e) {
  // activated only when there's member overflow from facepile
  stopPropagationAndPreventDefault(e);

  Analytics.sendClickedButtonEvent({
    buttonName: 'allBoardMembersButton',
    source: 'boardScreen',
  });

  const newInvitees = this.getNewlySignedUpInvitees();

  return PopOver.toggle({
    elem: this.$('.js-open-show-all-board-members'),
    view: BoardHeaderAllMembersView,
    options: {
      model: this.model,
      modelCache: this.modelCache,
      newInvitees,
    },
  });
};

export const openAddMembers = function (e) {
  const boardShareModalEnabled = featureFlagClient.get(
    'smoothie.board-invite-popover',
    false,
  );
  if (e) {
    stopPropagationAndPreventDefault(e);
  }
  const inviteButton = this.$('.js-open-manage-board-members');

  if (
    !boardShareModalEnabled && // Limits errors are being handled separately in the redesigned share modal
    maybeDisplayMemberLimitsError(inviteButton, this.model)
  ) {
    return;
  }
  Analytics.sendClickedButtonEvent({
    buttonName: boardShareModalEnabled ? 'shareButton' : 'inviteToBoardButton',
    source: 'boardScreen',
    attributes: {
      idBoard: this.model.id,
    },
  });

  if (boardShareModalEnabled) {
    Dialog.show({
      reactElement: (
        <LazyBoardInviteModal
          idBoard={this.model.id}
          idOrg={this.model.getOrganization()?.id}
          onClose={Dialog.hide}
        />
      ),
      ...dialogProps,
    });
  } else {
    const view = new BoardMemberAddMultipleView({
      model: this.model,
      modelCache: this.modelCache,
    });
    view.loadOrgData();

    PopOver.toggle({
      elem: inviteButton,
      view,
    });
  }
};

export const joinBoard = function (e) {
  stopPropagationAndPreventDefault(e);

  Analytics.sendClickedButtonEvent({
    buttonName: 'joinBoardButton',
    source: 'boardScreen',
  });

  if (maybeDisplayMemberLimitsError($(e.target), this.model, Auth.me())) {
    return;
  }

  const traceId = Analytics.startTask({
    taskName: 'edit-board/members/join',
    source: 'boardScreen',
  });

  this.$('.js-join-board').remove();

  this.model.joinBoard(
    traceId,
    tracingCallback(
      {
        taskName: 'edit-board/members/join',
        source: 'boardScreen',
        traceId,
      },
      (error, response) => {
        if (response) {
          Analytics.sendTrackEvent({
            action: 'joined',
            actionSubject: 'board',
            source: 'boardScreen',
            containers: {
              board: {
                id: this.model.id,
              },
              organization: {
                id: this.model.getOrganization()?.id,
              },
            },
            attributes: {
              taskId: traceId,
            },
          });
        }
      },
    ),
  );
};

export const showMemberProfile = function (member) {
  Controller.saveMemberBoardProfileLocation(member, this.model.id);
  Dialog.show({
    view: new MemberBoardProfileView({
      model: member,
      board: this.model,
      modelCache: this.modelCache,
    }),
    maxWidth: 500,
    hide: () => Controller.setBoardLocation(this.model.id),
  });
};
